<template>
  <div class="intro">
    <div class="header">
      <p class="title">
        Formation GTA
      </p>
      <p class="module-title">
        <slot name="module-title"></slot>
      </p>
    </div>
    <div class="requirements" v-if="requirements">
      <slot name="requirements"></slot>
    </div>
    <div class="content">
      <div class="learnings-wrapper">
        <p class="learnings-title">
          <slot name="learnings-title">
            Dans ce module, vous allez apprendre à...
          </slot>
        </p>
        <slot name="learnings" class="learnings"></slot>
      </div>
      <div class="rules-wrapper">
        <p class="rules-title">
          <slot name="rules-title">
            Les règles du jeu
          </slot>
        </p>
        <slot name="rules" class="rules"></slot>
      </div>
    </div>
    <div class="button-wrapper">
      <button @click="$emit('start')" class="button">{{ buttonLabel }}</button>
    </div>
    <p class="duration">
      {{ duration }} minutes
    </p>
    <div class="footer">
      <img src="../assets/cppro_logo.svg" width="214px">
      <img src="../assets/sgdbf_text.svg" width="300px">
      <img src="../assets/logo-sg.png">
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntroTemplate',
  props: {
    buttonLabel: {
      type: String,
      required: false,
      default () {
        return 'Commencer l\'activité'
      }
    },
    duration: {
      type: String,
      required: false,
      default () {
        return '5'
      }
    },
    requirements: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.intro {
  width: 100%;
  height: 100%;
  position: relative;
  flex-grow: 1;
  overflow: hidden;
  padding-bottom: 280px;
  &:after {
    content: 'GTA';
    position: absolute;
    color: rgba(255, 255, 255, 0.5);
    font-size: 341px;
    font-weight: 700;
    bottom: 0;
    right: 0;
    line-height: 235px;
  }
  .header {
    height: 160px;
    width: 1024px;
    max-width: 100%;
    background-color: $primary-color;
    color: #fff;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    margin: 0 auto;
    border-radius: 0 0 $radius $radius;
    padding: 0 40px;
    .title {
      font-family: $secondary-font;
      font-weight: bold;
      font-size: 0.95rem;
    }
    .module-title {
      font-weight: bold;
      font-size: 2.25rem;
      margin-top: 5px;
    }
  }
  .requirements {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    position: relative;
    padding-left: 120px;
    width: 1024px;
    background-color: #fff;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.16);
    margin: 10px auto;
    &:before {
      content: 'Pré-requis';
      position: absolute;
      color: #fff;
      font-weight: 700;
      font-size: 1.27rem;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: $primary-text-color;
      height: 100%;
      top: 0;
      left: 0;
      width: 175px;
    }
  }
  .content {
    width: 1024px;
    max-width: 100%;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.16);
    border-radius: $radius-sm;
    background-color: #fff;
    color: $primary-text-color;
    margin: 10px auto 0 auto;
    padding: 5px 5px 5px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .learnings-wrapper {
      text-align: left;
      flex-grow: 1;
      margin-right: 40px;
      .learnings-title {
        font-weight: bold;
        font-size: 1.25rem;
        padding: 20px 0;
      }

      p:not(.learnings-title) {
        height: 75px;
        display: flex;
        align-items: center;
        padding-left: 20px;
        font-family: $secondary-font;
        background-color: $background-color;
        color: $secondary-text-color;
        font-weight: bold;
        width: 100%;
        margin: 10px 0;
      }
    }
    .rules-wrapper {
      align-self: stretch;
      width: 390px;
      background-color: $primary-text-color;
      color: #fff;
      border-radius: $radius-sm;
      text-align: left;
      padding: 25px 30px;
      .rules-title {
        font-weight: bold;
        font-size: 1.25rem;
        padding-bottom: 10px;
      }
      .rule {
        margin-top: 20px;
        .label {
          font-weight: bold;
          font-size: 1.15rem;
        }
        .value {
          font-family: $secondary-font;
        }
      }
    }
  }
  .button-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
    margin-bottom: 15px;
  }
  .duration {
    color: $light-text-color;
    font-family: $secondary-font;
    font-size: 0.9rem;
  }
  .footer {
    z-index: 2;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 40px;
    height: 90px;
  }
}
</style>
